import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, token } = useAuth();

  // Autenticado não fica em tela pública: '/' delega ao
  // RedirectToDefaultRoute ('/automacoes' fixo mandava usuário sem a
  // feature automacoes pro /access-denied).
  if (isAuthenticated && token) {
    return <Navigate to="/" replace />;
  }

  // Se não estiver autenticado, renderizar o componente filho
  return <>{children}</>;
};

export default PublicRoute;
